import {
	MESApiService,
	type spParameter,
	getMomentTz,
} from "@dexteel/mesf-core";
import type { StatisticsFilter } from "../models/usage-statistic";

const moment = getMomentTz();

export const getUsageStatistics = async (filter?: StatisticsFilter) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (filter) {
		parameters.push({
			name: "Start",
			value: moment(filter.start).utc().toISOString(),
		});
		parameters.push({
			name: "End",
			value: moment(filter.end).utc().toISOString(),
		});
	}

	const resp = await apiService.callV2(
		"[MMS].[GetUsageStatistics]",
		parameters,
	);

	return resp;
};
